import React from 'react';
import { useState } from 'react';

import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { Alert, Snackbar, styled } from '@mui/material';

const Box = styled('div')`
  position: relative;
`;

const CopyToClipboard = ({ lat, lng }) => {
  const [copy, setCopy] = useState(false);

  const copyHandler = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(`${lat},${lng}`);
    setCopy(true);
  };

  return (
    <Box>
      {copy ? (
        <Snackbar
          sx={{ position: 'absolute', top: 0, left: 0, transform: 'translateX(-50%)' }}
          open={copy}
          onClose={() => setCopy(false)}
          autoHideDuration={3000}
        >
          <Alert severity="success" sx={{ width: '100%' }}>
            Skopírované
          </Alert>
        </Snackbar>
      ) : (
        <a href="#" onClick={copyHandler}>
          <ContentCopyRoundedIcon />
        </a>
      )}
    </Box>
  );
};

export default CopyToClipboard;
